import React, { FC, useEffect } from 'react';
import { useMobileMenuContext } from 'contexts';
import { Hexa } from './styled';
import { useTranslation } from 'react-i18next';
import { Intro, Books, Test, Constructor } from './components';

const ForSchools: FC = () => {
    const { toggleCorporateStyles } = useMobileMenuContext();
    const { t } = useTranslation('pages/for-schools-and-colleges');

    useEffect(() => {
        toggleCorporateStyles(true);

        window.scrollTo(0, 0);

        return () => {
            toggleCorporateStyles(false);
        };
    }, []);

    return (
        <>
            <Intro />
            <Constructor
                bgImagePath={
                    process.env.PUBLIC_URL +
                    '/assets/images/bussiness/construct-bg-gr.png'
                }
                title={t('constructor-title')}
            />
            <Books />
            <Test />
            <Hexa />
        </>
    );
};

export default ForSchools;
